import React, { useEffect } from "react";
import Form from 'react-bootstrap/Form';
import down_icn from "../../assets/images/down_icn.png";

import back_arrow from "../../assets/images/back_arrow.png";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Button } from "react-bootstrap";
import BackSecion from "../common/header";

var sectionStyle = {
    backgroundImage: `url(${down_icn})`
 }

/**
 * Renders Component.
 * @return {HomeWorksStu} renders Component.
 */
export default function HomeWorksStu() {
    useEffect(() => { }, []);

    return (
        <>
            <div className="cmmn">


                <Container className="d-flex height_100vh flex-column">
                <BackSecion name="HomeWorks" navigate_action="/home" />

                    <Row className="mt-4 px-075">
                        <Form.Group className="p-0">
                            <Form.Label className="f-10 fw-normal text-primary mt-3 ms-3">CLASS</Form.Label>

                            <Form.Select className="select_grey fee_gry p-075 rounded-3 border-0 dropdown-toggle f-14" aria-label="Default select example">
                                <option>Select Class</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                            </Form.Select>
                        </Form.Group>

                    </Row>
                    <Row className="mt-4 px-075">
                        <Col xs={6} className="ps-0 pe-1">
                            <div className="fee_gry rounded-3 p-2">
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-column">
                                        <p className="f-10 m-0">Date</p>
                                        <div className="f-14">Pending Fee</div>


                                    </div>




                                    <div className="text-end">
                                    <img src={down_icn} alt="..." className="mt-1" width="24px" height="24px"/>

                                    </div>
                                </div>

                            </div>
                        </Col>


                        <div className="col-6 pe-0 ps-1">
                            <div className="fee_gry rounded-3 p-2">
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-column">
                                        <p className="f-10 m-0">Date</p>
                                        <div className="f-14">Pending Fee</div>


                                    </div>




                                    <div className="text-end">
                                    <img src={down_icn} alt="..." className="mt-1" width="24px" height="24px"/>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Row>
                    <div className="row row_gap p-075 pr-075 mb-5">
                        <Form.Group className="p-0 d-flex flex-column">
                            <Form.Label className="f-10 fw-normal text-primary mt-3 ms-3">COMPOSE HOMEWORK</Form.Label>

                            <Form.Control as="textarea" rows={18} className="text_area_clr f-14" placeholder="Compose Homework here.." />
                            <div className="rounded-circle shadow-sm attach_file_tech ms-auto">

                            </div>


                        </Form.Group>

                    </div>
                    <div className="row mb-5 mt-auto">
                        <div className="col-12 d-grid gap-2 mb-4">
                            <Button className="btn btn-primary f-14 p-075">Post Home Work</Button>
                        </div>
                    </div>


                </Container>




            </div>

        </>
    );
}

